import Icon from "@Components/generic/icon";
import { faEllipsis } from "@fortawesome/pro-solid-svg-icons";
import { Box, Stack, SxProps, Typography, useTheme } from "@mui/material";
import { isNumber, isString } from "lodash-es";

enum BybHrVariant {
  DEFAULT = "default",
  LIST = "list",
}

interface IBybHr {
  variant?: `${BybHrVariant}`;
  ellipsis?: boolean;
  value?: string | number | React.ReactNode;
  sx?: SxProps;
}

const BybHr = ({ variant = BybHrVariant.DEFAULT, ellipsis, value, sx }: IBybHr) => {
  const theme = useTheme();
  const color = variant === BybHrVariant.DEFAULT ? "dsSurface.v300" : "dsSurface.v400";

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        display: "flex",
        alignItems: "center",
        padding: variant === BybHrVariant.DEFAULT ? 0 : theme.spacing(1.25, 2.5),
        boxSizing: "border-box",
        ...sx,
      }}
    >
      {variant === BybHrVariant.DEFAULT ? (
        <Box
          sx={{
            width: "100%",
            height: theme.spacing(0.25),
            backgroundColor: color,
          }}
        />
      ) : (
        <Stack
          direction="row"
          spacing={1.25}
          sx={{
            width: "100%",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: theme.spacing(0.125),
              backgroundColor: color,
            }}
          />
          {ellipsis ? (
            <>
              {/* TODO: use Vuesax icons */}
              <Icon icon={faEllipsis} color={theme.palette.dsNeutral.v200} sx={{ display: "flex" }} />
            </>
          ) : isString(value) || isNumber(value) ? (
            <Typography variant="textS500" sx={{ color: "dsNeutral.v300" }}>
              {value}
            </Typography>
          ) : (
            value
          )}
          <Box
            sx={{
              width: "100%",
              height: theme.spacing(0.125),
              backgroundColor: color,
            }}
          />
        </Stack>
      )}
    </Box>
  );
};

export default BybHr;
